/* eslint-disable */
import { logger } from 'packages';
import onReady from 'utils/on-ready';
import {
    isSearchFilterExperienceEnabled,
    isBrowseFilterExperienceEnabled,
    isDiscoverOnCustomResultPageEnabled
} from '../../../../../frontend/apps/discover/helpers/enabled-features';

export default async initData => {
    const mod = initData.module.split('/');
    switch (mod[4]) {
        case 'bin-form':
            return await import(
                /* webpackChunkName: "bin-form" */ './bin-form'
            );
        case 'cart-checkout':
            return await import(
                /* webpackChunkName: "cart-checkout" */ './cart-checkout'
            );
        case 'cart-overview':
            return await import(
                /* webpackChunkName: "cart-overview" */ './cart-overview'
            );
        case 'cart-paypal-payment':
            return await import(
                /* webpackChunkName: "cart-paypal-payment" */ './cart-paypal-payment'
            );
        case 'checkout-select-payment':
            return await import(
                /* webpackChunkName: "checkout-select-payment" */ './checkout-select-payment'
            );
        case 'checkout2':
            return await import(
                /* webpackChunkName: "checkout2" */ './checkout2'
            );
        case 'klarna-pin':
            return await import(
                /* webpackChunkName: "klarna-pin" */ './klarna-pin'
            );
        case 'klarna-signup':
            return await import(
                /* webpackChunkName: "klarna-signup" */ './klarna-signup'
            );
        case 'basic':
            return await import(/* webpackChunkName: "basic" */ './basic');
        case 'category':
            if (isBrowseFilterExperienceEnabled(initData)) {
                return await import(
                    /* webpackChunkName: "discover" */ '../../../../../frontend/apps/discover/'
                );
            } else {
                return await import(
                    /* webpackChunkName: "category-results" */ './category'
                );
            }
        case 'bidding':
            return await import(/* webpackChunkName: "bidding" */ './bidding');
        case 'category-list': //page kategorier
            return await import(
                /* webpackChunkName: "category-list" */ './category-list'
            );

        case 'messaging':
            return await import(
                /* webpackChunkName: "messaging-iframe" */ './messaging'
            );
        case 'custom-results':
            if (isDiscoverOnCustomResultPageEnabled(initData)) {
                return await import(
                    /* webpackChunkName: "discover" */ '../../../../../frontend/apps/discover/'
                );
            } else {
                return await import(
                    /* webpackChunkName: "custom-results" */ './custom-results/'
                );
            }
        case 'detailed-search':
            return await import(
                /* webpackChunkName: "detailed-search" */ './detailed-search'
            );
        case 'messages':
            return await import(
                /* webpackChunkName: "messages" */ './messages'
            );
        case 'profile':
            return await import(/* webpackChunkName: "profile" */ './profile');
        case 'search-results':
            if (isSearchFilterExperienceEnabled(initData)) {
                return await import(
                    /* webpackChunkName: "discover" */ '../../../../../frontend/apps/discover/'
                );
            } else {
                return await import(
                    /* webpackChunkName: "search-results" */ './search-results/'
                );
            }
        case 'start-page':
            return await import(
                /* webpackChunkName: "start-page" */ './start-page/start-page'
            );
        case 'view-item':
            return await import(
                /* webpackChunkName: "view-item" */ './view-item/'
            );
        case 'endless-recommendation':
            return await import(
                /* webpackChunkName: "endless-recommendation" */ './endless-recommendation/'
            );
        case 'brand':
            return await import(/* webpackChunkName: "brand" */ './brand/');
        case 'image-search':
            return await import(
                /* webpackChunkName: "image-search" */ '../../../../../frontend/apps/image-search/'
            );
        default:
            return await import(/* webpackChunkName: "basic" */ './basic');
    }
};
